(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/aria-countdown-timer.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/aria-countdown-timer.js');
'use strict';

const nextMultipleOf10 = num => Math.ceil(num / 10) * 10;

const AriaCountdownTimer = _ref => {
  let {
    startTime,
    showTime = 280,
    onDone,
    children
  } = _ref;
  const [timeLeft, setTimeLeft] = React.useState(startTime);
  const timeoutRef = React.useRef(null);
  const isDone = React.useRef(false);
  React.useEffect(() => {
    if (timeLeft <= 0 && !isDone.current) {
      isDone.current = true;
      onDone === null || onDone === void 0 || onDone();
    }
  }, [timeLeft, onDone]);
  React.useEffect(() => {
    let expected = Date.now() + 1000;
    const SECOND = 1000;
    const tick = () => {
      setTimeLeft(prev => Math.max(prev - 1, 0));
      const drift = Date.now() - expected;
      expected += SECOND;
      timeoutRef.current = setTimeout(tick, SECOND - drift);
    };
    timeoutRef.current = setTimeout(tick, SECOND);
    return () => clearTimeout(timeoutRef.current);
  }, []);
  return (
    React.createElement(React.Fragment, null, timeLeft <= showTime && React.createElement(React.Fragment, null, timeLeft >= 59 && timeLeft % 60 <= 4 && React.createElement("div", {
      "aria-live": "assertive",
      className: "aria-countdown-timer-screen-reader",
      role: "timer"
    }, "Tid kvar: ".concat(Math.ceil(timeLeft / 60), " minuter")), timeLeft <= 32 && React.createElement("div", null, React.createElement("div", {
      "aria-live": "assertive",
      className: "aria-countdown-timer-screen-reader",
      role: "timer"
    }, "Tid kvar: ".concat(nextMultipleOf10(timeLeft), " sekunder")), React.createElement("div", null, "Tid kvar: ".concat(timeLeft, " s"))), children))
  );
};
svs.playerLoginReact.sharedComponents.AriaCountdownTimer = AriaCountdownTimer;

 })(window);